// Configure axios defaults
import axios from 'axios';

// Use REACT_APP_API_URL from .env if set, otherwise fall back to localhost for local dev
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

axios.defaults.baseURL = API_BASE_URL;

export default axios;
